export default __webpack_public_path__ + "static/media/brand.975cf7ee.jpg";